import { QUOTE_STATUSES } from '../../utils/constants';

export default {
  data: {
    createQuote: {
      quoteId: 'xx-xxx-xxx-xxx',
      status: 'DRAFT',
      product: 'NOFB',
      make: {
        id: 100030,
        name: 'MASERATI'
      },

      model: {
        id: 100607,
        name: 'GranTurismo'
      },
      variant: {
        id: 171044,
        name: 'MC Stradale MC-Shift',
        gears: '6',
        induction: '-',
        driveType: '-',
        power: '-',
        torque: '-',
        greenStarRating: '-',
        ancapRating: '-',
        modelYear: '2015',
        external_code: 'AUVMASE2015AECL',
        listPriceNet: '254514.13',
        listPriceGst: '25451.41',
        listPriceGross: '345000.00',
        derivativeId: '-',
        derivative: '-',
        fuelTypeId: 100007,
        fuelType: 'PULP',
        engineSize: 4691,
        engineCylinders: 8,
        engineDescription: '8cyl, 4.7L',
        co2Emissions: 337,
        grossUnloadedWeight: 1800,
        grossLoadedWeight: 2250,
        grossTowedWeight: 0,
        fuelConsumption: '0.0',
        fuelConsumptionHighway: '0.0',
        fuelConsumptionCombined: '14.4',
        trimId: '-',
        trim: '-',
        transmissionId: 'SportsAutomaticDualClutch',
        transmission: 'Sports Automatic Dual Clutch',
        transmissionGroupId: '-',
        doors: '2',
        seats: '4',
        serviceGroup: '20000/24MONTHS',
        length: '-',
        height: '-',
        fuelTankCapacity: 86,
        octaneRating: '-',
        warrantyMonths: 36,
        warrantyKms: 0,
        bodyTypeId: 100004,
        photos: [
          {
            type: 'side',
            path: 'https://fleetplus.catch-e.net.au/core/services/Redbook/photos/AUS//MASE019F.jpg'
          },
          {
            type: 'front',
            path: 'https://fleetplus.catch-e.net.au/core/services/Redbook/photos/AUS//MASE019G.jpg'
          }
        ]
      },
      bodyType: 'COUPE',
      availableOptions: {},
      leaseTerm: 48,
      kmsPerYear: 20000,
      leaseStart: '-',
      leaseEnd: '-',
      leaseOptions: [],
      exteriorColour: 'green',
      interiorColour: '-',
      includedEquipment: [],
      optionalEquipment: [],
      adhocEquipment: [],
      insuranceProvider: 'Suncrops pty ltd',
      customer: {
        companyName: 'aaaaa',
        companyAbn: '5362945511',
        customerName: 'Bob Millet',
        customerContactEmail: '-',
        customerContactNumber: '',
        deliveryAddressLine1: '',
        deliveryAddressLine2: '',
        deliverySuburb: '',
        deliveryState: '',
        deliveryPostcode: '',
        deliveryDate: '',
        dealership: '',
        registrationPostcode: ''
      },
      novated: {
        budgets: [
          {
            type: 'Fuel',
            cost: 2000
          }
        ],
        fees: [
          {
            type: 'Fuel Card',
            cost: 250
          }
        ],
        grossSalary: 90000,
        preTaxDeduction: 10000,
        netTaxableIncome: 80000,
        incomeTax: 24000,
        postTaxDeduction: 5000,
        netIncome: 56000,
        taxSaving: 1000,
        gstSavingBudget: 500,
        gstSavingVehicle: 3000,
        impactTakeHome: 200,
        residualValue: 25000
      },
      price: {
        onRoadCost: 65000,
        fbtValue: 6500,
        listPrice: 65000,
        listPriceNet: 65000,
        listPriceGst: 6500,
        listPriceGross: 65000,
        monthlyRentalNet: 650,
        monthlyRentalGst: 65,
        monthlyRentalGross: 650,
        weeklyRentalNet: 150
      }
    },
    getQuote: {
      quoteId: 'xx-xxx',
      status: QUOTE_STATUSES.DRAFT.value,
      product: 'NOFB',
      make: {
        id: 100030,
        name: 'MASERATI'
      },

      model: {
        id: 100607,
        name: 'GranTurismo'
      },
      variant: {
        id: 171044,
        name: 'MC Stradale MC-Shift',
        gears: '6',
        induction: '-',
        driveType: '-',
        power: '-',
        torque: '-',
        greenStarRating: '-',
        ancapRating: '-',
        modelYear: '2015',
        external_code: 'AUVMASE2015AECL',
        listPriceNet: '254514.13',
        listPriceGst: '25451.41',
        listPriceGross: '345000.00',
        derivativeId: '-',
        derivative: '-',
        fuelTypeId: 100007,
        fuelType: 'PULP',
        engineSize: 4691,
        engineCylinders: 8,
        engineDescription: '8cyl, 4.7L',
        co2Emissions: 337,
        grossUnloadedWeight: 1800,
        grossLoadedWeight: 2250,
        grossTowedWeight: 0,
        fuelConsumption: '0.0',
        fuelConsumptionHighway: '0.0',
        fuelConsumptionCombined: '14.4',
        trimId: '-',
        trim: '-',
        transmissionId: 'SportsAutomaticDualClutch',
        transmission: 'Sports Automatic Dual Clutch',
        transmissionGroupId: '-',
        doors: 2,
        seats: 4,
        serviceGroup: '20000/24MONTHS',
        length: '-',
        height: '-',
        fuelTankCapacity: 86,
        octaneRating: '-',
        warrantyMonths: 36,
        warrantyKms: 0,
        bodyTypeId: 100004,
        photos: [
          {
            type: 'side',
            path: 'https://fleetplus.catch-e.net.au/core/services/Redbook/photos/AUS//MASE019F.jpg'
          },
          {
            type: 'front',
            path: 'https://fleetplus.catch-e.net.au/core/services/Redbook/photos/AUS//MASE019G.jpg'
          }
        ]
      },
      bodyType: 'COUPE',
      availableOptions: {},
      leaseTerm: 48,
      kmsPerYear: 20000,
      leaseStart: '-',
      leaseEnd: '-',
      leaseOptions: [],
      exteriorColour: 'green',
      interiorColour: '-',
      includedEquipment: [],
      optionalEquipment: [],
      adhocEquipment: [],
      insuranceProvider: 'Suncrops pty ltd',
      customer: {
        companyName: 'aaaaa',
        companyAbn: '5362945511',
        customerName: 'Bob Millet',
        customerContactEmail: '-',
        customerContactNumber: '',
        deliveryAddressLine1: '',
        deliveryAddressLine2: '',
        deliverySuburb: '',
        deliveryState: '',
        deliveryPostcode: '',
        deliveryDate: '',
        dealership: '',
        registrationPostcode: ''
      },
      novated: {
        budgets: [
          {
            type: 'Fuel',
            cost: 2000
          }
        ],
        fees: [
          {
            type: 'Fuel Card',
            cost: 250
          }
        ],
        grossSalary: 90000,
        preTaxDeduction: 10000,
        netTaxableIncome: 80000,
        incomeTax: 24000,
        postTaxDeduction: 5000,
        netIncome: 56000,
        taxSaving: 1000,
        gstSavingBudget: 500,
        gstSavingVehicle: 3000,
        impactTakeHome: 200,
        residualValue: 25000
      },
      price: {
        onRoadCost: 65000,
        fbtValue: 6500,
        listPrice: 65000,
        listPriceNet: 65000,
        listPriceGst: 6500,
        listPriceGross: 65000,
        monthlyRentalNet: 650,
        monthlyRentalGst: 65,
        monthlyRentalGross: 650,
        weeklyRentalNet: 150
      }
    },
    getVariantOptions: {
      exteriorColours: [
        {
          id: 'E29025',
          code: '291734',
          name: 'Brilliant Black',
          colourGroup: 'black',
          standard: true,
          requires: {
            OR: [
              'I51345',
              'I37418',
              'I71726',
              'I53514',
              'I71727',
              'I64557',
              'I53481',
              'I71728',
              'I71729',
              'I71730',
              'I36424'
            ]
          },
          precludes: {
            AND: [
              'O844',
              'O1621',
              'E53510',
              'E53753',
              'E29791',
              'E29767',
              'E53506',
              'E53505',
              'E53507',
              'E55776',
              'E55882',
              'E53508',
              'E28937',
              'E68687',
              'E68686',
              'E88687',
              'E89565',
              'E89564',
              'E65991'
            ]
          }
        },
        {
          id: 'E55882',
          code: '291739',
          name: 'Dakota Grey Metallic',
          colourGroup: 'gray',
          standard: false,
          requires: {
            AND: [
              'O844',
              {
                OR: [
                  'I51345',
                  'I37418',
                  'I71726',
                  'I53514',
                  'I71727',
                  'I64557',
                  'I53481',
                  'I71728',
                  'I71729',
                  'I71730',
                  'I36424'
                ]
              }
            ]
          },
          precludes: {
            AND: [
              'E53510',
              'E53753',
              'E29791',
              'E29767',
              'E29025',
              'E53506',
              'E53505',
              'E53507',
              'E55776',
              'E53508',
              'E28937',
              'E68687',
              'E68686',
              'E88687',
              'E89565',
              'E89564',
              'E65991'
            ]
          }
        },
        {
          id: 'E53506',
          code: '291735',
          name: 'Scuba Blue',
          colourGroup: 'blue',
          standard: false,
          requires: {
            AND: [
              'O844',
              {
                OR: [
                  'I51345',
                  'I37418',
                  'I71726',
                  'I53514',
                  'I71727',
                  'I64557',
                  'I53481',
                  'I71728',
                  'I71729',
                  'I71730',
                  'I36424'
                ]
              }
            ]
          }
        }
      ],
      interiorColours: [
        {
          id: 'I71726',
          code: '121385',
          name: 'Velvet Beige Nappa Leather',
          colourGroup: 'beige',
          type: 'Leather',
          requires: {
            AND: ['O37290']
          },
          precludes: {
            AND: [
              'I51345',
              'I37418',
              'I53514',
              'I71727',
              'I64557',
              'I53481',
              'I71728',
              'I71729',
              'I71730',
              'I36424',
              'O90300'
            ]
          }
        },
        {
          id: 'I71730',
          code: '121392',
          name: 'Crimson Red / Black',
          colourGroup: 'red',
          type: 'Leather',
          requires: {
            OR: ['O64381', 'O64385', 'O90300']
          },
          precludes: {
            AND: [
              'O37290',
              'I51345',
              'I37418',
              'I71726',
              'I53514',
              'I71727',
              'I64557',
              'I53481',
              'I71728',
              'I71729',
              'I36424'
            ]
          }
        },
        {
          id: 'I51345',
          code: '121394',
          name: 'Red Fine Nappa Leather',
          colourGroup: 'red',
          type: 'Leather',
          requires: {
            AND: ['O37290']
          },
          precludes: {
            AND: [
              'I37418',
              'I71726',
              'I53514',
              'I71727',
              'I64557',
              'I53481',
              'I71728',
              'I71729',
              'I71730',
              'I36424',
              'O90300'
            ]
          }
        },
        {
          id: 'I37418',
          code: '121393',
          name: 'Black Milano Leather',
          colourGroup: 'black',
          type: '',
          requires: [],
          precludes: {
            AND: [
              'O37290',
              'I51345',
              'I71726',
              'I53514',
              'I71727',
              'I64557',
              'I53481',
              'I71728',
              'I71729',
              'I71730',
              'I36424',
              'O90300'
            ]
          }
        }
      ],
      optionalEquipment: [
        {
          id: 'O28548',
          code: '15163290',
          name: 'Sports Suspension',
          amountNet: 489.51,
          amountGst: 48.95,
          amountGross: 538.46,
          requires: [],
          precludes: []
        },
        {
          id: 'O51562',
          code: '15163263',
          name: 'Dynamic Steering',
          amountNet: 1818.18,
          amountGst: 181.82,
          amountGross: 2000,
          requires: [],
          precludes: []
        },
        {
          id: 'O34948',
          code: '15163279',
          name: 'Sports steering wheel with paddle shift',
          amountNet: 244.76,
          amountGst: 24.48,
          amountGross: 269.24,
          requires: [],
          precludes: []
        },
        {
          id: 'O51453',
          code: '15163276',
          name: 'Flat Bottomed Sports Steering Wheel with gearshift paddles',
          amountNet: 489.51,
          amountGst: 48.95,
          amountGross: 538.46,
          requires: [],
          precludes: []
        },
        {
          id: 'O29111',
          code: '15163271',
          name: 'Heated front seats',
          amountNet: 559.44,
          amountGst: 55.94,
          amountGross: 615.38,
          requires: [],
          precludes: []
        },
        {
          id: 'O64375',
          code: '15163277',
          name: '18 Alloy wheels 5 V-spoke Design 245 /40 R18',
          amountNet: 0,
          amountGst: 0,
          amountGross: 0,
          requires: [],
          precludes: {
            AND: [
              'O37319',
              'O88494',
              'O88495',
              'O90301',
              'O90302',
              'O64381',
              'O64385'
            ]
          }
        },
        {
          id: 'O90302',
          code: '15163289',
          name: '19 Alloy wheels - 10-spoke design',
          amountNet: 1258.74,
          amountGst: 125.87,
          amountGross: 1384.61,
          requires: [],
          precludes: {
            AND: [
              'O37319',
              'O64375',
              'O88494',
              'O88495',
              'O90301',
              'O64381',
              'O64385'
            ]
          }
        },
        {
          id: 'O90300',
          code: '15163265',
          name: 'S line sport Nappa leather upgrade',
          amountNet: 139.86,
          amountGst: 13.99,
          amountGross: 153.85,
          requires: {
            OR: ['O64381', 'O64385']
          },
          precludes: {
            AND: [
              'O37290',
              'I51345',
              'I37418',
              'I71726',
              'I53514',
              'I71727',
              'I64557',
              'I53481',
              'I71728',
              'I36424'
            ]
          }
        },
        {
          id: 'O78739',
          code: '15163280',
          name: 'Digital radio',
          amountNet: 559.44,
          amountGst: 55.94,
          amountGross: 615.38,
          requires: [],
          precludes: []
        },
        {
          id: 'O64381',
          code: '15249465',
          name: 'S-Line sport Package 19 wheels',
          amountNet: 2307.69,
          amountGst: 230.77,
          amountGross: 2538.46,
          requires: {
            AND: ['O51453', 'O28548']
          },
          precludes: {
            AND: [
              'O37319',
              'O64375',
              'O88494',
              'O88495',
              'O90301',
              'O90302',
              'O64385'
            ]
          }
        },
        {
          id: 'O64381',
          code: '15359946',
          name: 'S-Line sport Package 19 wheels',
          amountNet: 2307.69,
          amountGst: 230.77,
          amountGross: 2538.46,
          requires: {
            AND: ['O51453', 'O28548']
          },
          precludes: {
            AND: [
              'O37319',
              'O64375',
              'O88494',
              'O88495',
              'O90301',
              'O90302',
              'O64385'
            ]
          }
        },
        {
          id: 'O64381',
          code: '15197991',
          name: 'S-Line sport Package 19 wheels',
          amountNet: 2307.69,
          amountGst: 230.77,
          amountGross: 2538.46,
          requires: {
            AND: ['O51453', 'O28548']
          },
          precludes: {
            AND: [
              'O37319',
              'O64375',
              'O88494',
              'O88495',
              'O90301',
              'O90302',
              'O64385'
            ]
          }
        },
        {
          id: 'O64381',
          code: '15163291',
          name: 'S-Line sport Package 19 wheels',
          amountNet: 2307.69,
          amountGst: 230.77,
          amountGross: 2538.46,
          requires: {
            AND: ['O51453', 'O28548']
          },
          precludes: {
            AND: [
              'O37319',
              'O64375',
              'O88494',
              'O88495',
              'O90301',
              'O90302',
              'O64385'
            ]
          }
        },
        {
          id: 'O64385',
          code: '15249466',
          name: 'S-Line sport Package 20 wheels',
          amountNet: 2797.2,
          amountGst: 279.72,
          amountGross: 3076.92,
          requires: {
            AND: ['O51453', 'O28548']
          },
          precludes: {
            AND: [
              'O37319',
              'O64375',
              'O88494',
              'O88495',
              'O90301',
              'O90302',
              'O64381'
            ]
          }
        },
        {
          id: 'O64385',
          code: '15359947',
          name: 'S-Line sport Package 20 wheels',
          amountNet: 2797.2,
          amountGst: 279.72,
          amountGross: 3076.92,
          requires: {
            AND: ['O51453', 'O28548']
          },
          precludes: {
            AND: [
              'O37319',
              'O64375',
              'O88494',
              'O88495',
              'O90301',
              'O90302',
              'O64381'
            ]
          }
        },
        {
          id: 'O64385',
          code: '15197992',
          name: 'S-Line sport Package 20 wheels',
          amountNet: 2797.2,
          amountGst: 279.72,
          amountGross: 3076.92,
          requires: {
            AND: ['O51453', 'O28548']
          },
          precludes: {
            AND: [
              'O37319',
              'O64375',
              'O88494',
              'O88495',
              'O90301',
              'O90302',
              'O64381'
            ]
          }
        },
        {
          id: 'O64385',
          code: '15163294',
          name: 'S-Line sport Package 20 wheels',
          amountNet: 2797.2,
          amountGst: 279.72,
          amountGross: 3076.92,
          requires: {
            AND: ['O51453', 'O28548']
          },
          precludes: {
            AND: [
              'O37319',
              'O64375',
              'O88494',
              'O88495',
              'O90301',
              'O90302',
              'O64381'
            ]
          }
        },
        {
          id: 'O68016',
          code: '15249467',
          name: 'Technology Package',
          amountNet: 1748,
          amountGst: 174.8,
          amountGross: 1922.8,
          requires: {
            AND: ['O28701']
          },
          precludes: {
            AND: ['O85126']
          }
        },
        {
          id: 'O68016',
          code: '15359943',
          name: 'Technology Package',
          amountNet: 1748,
          amountGst: 174.8,
          amountGross: 1922.8,
          requires: {
            AND: ['O28701']
          },
          precludes: {
            AND: ['O85126']
          }
        }
      ],
      includedEquipment: [
        {
          id: 'O120719',
          code: '15358656',
          name: '17 Nov 2016, 1, 788,414,208, internal and 17 Nov 2016',
          amountNet: 0,
          amountGst: 0,
          amountGross: 0,
          requires: [],
          precludes: []
        },
        {
          id: 'O99994',
          code: '15358657',
          name: 'Emission control level EU6 and 146 (g/km) carbon dioxide level',
          amountNet: 0,
          amountGst: 0,
          amountGross: 0,
          requires: [],
          precludes: []
        },
        {
          id: 'OFP0302',
          code: '15358658',
          name: 'Front Fog Lights',
          amountNet: 0,
          amountGst: 0,
          amountGross: 0,
          requires: [],
          precludes: []
        },
        {
          id: 'OFP0302',
          code: '15247627',
          name: 'Front Fog Lights',
          amountNet: 0,
          amountGst: 0,
          amountGross: 0,
          requires: [],
          precludes: []
        },
        {
          id: 'OFP0302',
          code: '15195919',
          name: 'Front Fog Lights',
          amountNet: 0,
          amountGst: 0,
          amountGross: 0,
          requires: [],
          precludes: []
        }
      ]
    }
  }
};
